import { render, staticRenderFns } from "./jenisdinding.vue?vue&type=template&id=9e2c6f8c"
import script from "./jenisdinding.vue?vue&type=script&lang=js"
export * from "./jenisdinding.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports